import React from "react";
// import Home from "../src/containers/Home/home";
import Home from "../src/containers/AGL/Home";
import Tracks from "../src/containers/tracks";
import Dashboard from "../src/containers/AGL/Dashboard";
// import Dashboard from "../src/containers/dashboard";
import CustomDashboard from "../src/containers/customDashboard";
import Reports from "../src/containers/reports";
import Operations from "../src/containers/operations";
import ReportsPage from "../src/containers/reports/reportspage";
import MasterCompany from "./containers/Administrations/MasterCompany";
import MasterCreate from "./containers/Administrations/MasterCreate";
import Viewcompany from "./containers/Administrations/Viewcompany";
import RoleManagement from "./containers/Administrations/RoleManagement";
import ResetUser from "./containers/Administrations/UserManagement/ResetUser";
import UserManagement from "./containers/Administrations/UserManagement/UserManagement";
import EmailLog from "./containers/Administrations/EmailLog/EmailLog";
import SmsLog from "./containers/Administrations/SMSLog/SmsLog";
import MasterTable from "./containers/Administrations/MasterTable/MasterTable";
import Tripbreakreport from "./containers/reports/Trip break report/tripbreakreport";
import EntityManagement from "./containers/Administrations/EntityManagement/EntityManagement";
import Consignordetails from "./containers/Administrations/EntityManagement/Consignordetails";
import TenantSubscription from "./containers/Administrations/TenantSubscription/TenantSubscription";
import Notification from "./containers/Notification/Notification";
import LiveTracking from "./containers/Administrations/LiveTracking/LiveTracking";
import {
  Kpireport,
  KpireportFilter,
} from "./containers/reports/Kpireport/Kpireport";
import AnalyticsDashboard from "./containers/Analytics/Dashboard/Dashboard";
import Carbonfootprints from "./containers/reports/Carbonfootprints/Carbonfootprints";
import TripAllowance from "./containers/reports/TripAllowance/TripAllowance";
import Vehiclereport from "./containers/reports/VehicleReport/Vehiclereport";
import Trend from "./containers/Analytics/Trend";
import FuelReport from "./containers/reports/FuelReport/FuelReport";
import Productivity from "./containers/Analytics/Productivity/Productivity";
import Demographics from "./containers/Analytics/Demographics";
import CustomerReport from "./containers/reports/CustomerReport/CustomerReport";
import Consignment1 from "./containers/Operations/Fuelentry/Consignment Operation/Consignment1";
import ConsignCode from "./containers/consignment/consigncode/consigncode";
import FuelEntry1 from "./containers/Operations/Fuelentry/FuelEntry1";
import FuelDetails from "./containers/fuelentry/fueldetails";
import TripList1 from "./containers/Operations/Fuelentry/Trip List Operation/TripList1";
import TripCode from "./containers/Operations/Fuelentry/Trip List Operation/TripCode";
import Kpimaster from "./containers/Administrations/Kpimaster";
import TrackLink from "./containers/Operations/Fuelentry/TrackLink";
import ContainerReports from "./containers/containerTracking/containerReports";
import TripMonitoring from "./containers/containerTracking/tripMonitoring";
import TripTrack from "./containers/containerTracking/tripTrack";
import TripDetails from "./containers/containerTracking/tripDetails";
import TripReports from "./containers/containerTracking/TripReports";
import KpiReports from "./containers/containerTracking/kpiReports";
import CarbonReport from "./containers/containerTracking/carbonReport";
import ConsignmentAI from "./containers/TrackRightAI/consignmentAI";
import FuelEntryAI from "./containers/TrackRightAI/fuelEntryAI";
import TripListAI from "./containers/TrackRightAI/tripListAI";
import TrackLinkAI from "./containers/TrackRightAI/TrackLinkAI";
import ContainerDashboard from "./containers/AGL/ContainerDashboard";
import AIDashboard from "./containers/AGL/AIDashboard";
import CustomerReportAI from "./containers/ReportAI/CustomerReportAI/CustomerReportAI";
import FuelReportAI from "./containers/ReportAI/FuelReportAI/FuelReportAI";
import VehicleReportAI from "./containers/ReportAI/VehicleReportAI/VehicleReportAI";
import TripReportPage from "./containers/ReportAI/TripReportAI/ReportpageAI";
import KpiReportAI from "./containers/ReportAI/KpiReportAI/KpiReportAI";
import TripAllowanceAI from "./containers/ReportAI/TripAllowanceAI/TripAllowance";
import CarbonfootprintAI from "./containers/ReportAI/CarbonfootprintAI/CarbonfootprintAI";
import TripBreakAI from "./containers/ReportAI/TripBreakReportAI/TripBreakAI";
import CustomDashboardAI from "./containers/AGL/CustomDashboard/CustomDashboardAI";
import GeoFenceSwitch from "./containers/Administrations/GeoFence/GeoFenceSwitch";
import GeoDetails from "./containers/Administrations/GeoFence/GeoDetails";
import Route from "./containers/Administrations/RouteManagement/Route";
import RouteDetails from "./containers/Administrations/RouteManagement/RouteDetails";
import LiveTrackSwitch from "./containers/LiveTrack/LiveTrackSwitch";
import Trackinghistory from "./containers/LiveTrack/Tracking history";
import Role from "./containers/Administrations/RoleNewDesign/Role";
import Workshop from "./containers/Workshop/Workshop";
import InsuranceDashboard from "./containers/Workshop/InsuranceDashboard/InsuranceDashboard";
import InspectionDashboard from "./containers/Workshop/ServiceDashboard/ServiceDashboard";
import ServiceDetails from "./containers/Workshop/ServiceDetails/ServiceDetails";
import SpeedGovernorDashboard from "./containers/Workshop/SpeedGovernor/SpeedGovernor";
import NexusAI from "./containers/TrackRightAI/nexus-AI";
import NexusDashboardAI from "./containers/TrackRightAI/nexusDashboardAI";
import NexusTripListAI from "./containers/TrackRightAI/nexusTrip-AI";
import NexusTripReport from "./containers/ReportAI/NexusTripReport/NexusTripReport";
import NexusKpiReport from "./containers/ReportAI/NexusKpiReport/NexusKpiReport";
import NexusTripAllowanceReport from "./containers/ReportAI/NexusTripAllowanceReport/NexusTripAllowanceReport";
import NexusFuelReport from "./containers/ReportAI/NexusFuelReport/NexusFuelReport";
import NexusCarbonReport from "./containers/ReportAI/NexusCarbonReport/NexusCarbonReport";
import NexusCustomerReport from "./containers/ReportAI/NexusCustomerReport/NexusCustomerReport";
import NexusVehicleReport from "./containers/ReportAI/NexusVehicleReport/NexusVehicleReport";
import NexusTrackLinkAI from "./containers/TrackRightAI/nexusTrackLinkAI";
import NexusFuelAI from "./containers/TrackRightAI/nexusFuel-AI";
import NexusGeoFence from "./containers/Administrations/Nexus-GeoFence/NexusGeo";
import NexusGeoDetails from "./containers/Administrations/Nexus-GeoFence/NexusGeoDetails";
import MileageReport from "./containers/reports/MileageReport/MileageReport";
import AIChat from "./containers/AIChat/AIChat";
import ContainerRegister from "./containers/AGL/ContainerRegister";
const RoutesPath = [
  {
    path: "/AIChat",
    title: "AI Assistant",
    content: () => <AIChat />,
  },
  {
    path: "/",
    title: "Home",
    content: () => <Home />,
  },
  // {
  //   path: "/home",
  //   title: "Home",
  //   content: () => <Home />,
  // },
  {
    path: "/Home",
    title: "Home",
    content: () => <Home />,
  },
  {
    path: "/Dashboard",
    title: "Dashboard",
    content: () => <Dashboard />,
  },
  {
    path: "/container-dashboard",
    title: "TrackRight AI Cargo Dashboard",
    content: () => <ContainerDashboard />,
  },
  {
    path: "/AIDashboard",
    title: "AIDashboard",
    content: () => <AIDashboard />,
  },
  {
    path: "/tracks",
    title: "Tracks",
    content: () => <Tracks />,
  },
  // {
  //   path: "/dashboard",
  //   title: "Dashboard",
  //   content: () => <Dashboard />,
  // },
  {
    path: "/customDashboard",
    title: "CustomDashboard",
    content: () => <CustomDashboard />,
  },
  {
    path: "/reports",
    title: "Reports",
    content: () => <Reports />,
  },
  {
    path: "/operations",
    title: "Operations",
    content: () => <Operations />,
  },
  {
    path: "/Consignment1",
    title: "Consignment",
    content: () => <Consignment1 />,
  },

  {
    path: "/consigncode",
    title: "Consigncode",
    content: () => <ConsignCode />,
  },
  {
    path: "/TripList1",
    title: "TripList",
    content: () => <TripList1 />,
  },
  {
    path: "/TripCode",
    title: "TripCode",
    content: () => <TripCode />,
  },
  {
    path: "/FuelEntry1",
    title: "Fuel Entry",
    content: () => <FuelEntry1 />,
  },
  {
    path: "/FuelDetails",
    title: "Fuel Details",
    content: () => <FuelDetails />,
  },
  {
    path: "/tripreport",
    title: "Trip Report",
    content: () => <ReportsPage />,
  },
  {
    path: "/vehiclereport",
    title: "Vehicle Report",
    content: () => <Vehiclereport />,
  },
  {
    path: "/mileage-report",
    title: "Mileage Report",
    content: () => <MileageReport />,
  },
  {
    path: "/fuelreport",
    title: "Fuel Report",
    content: () => <FuelReport />,
  },
  {
    path: "/customerreport",
    title: "Customer Report",
    content: () => <CustomerReport />,
  },
  {
    path: "/MasterCompany",
    title: "MasterCompany",
    content: () => <MasterCompany />,
  },
  {
    path: "MasterCreate",
    title: "MasterCreate",
    content: () => <MasterCreate />,
  },

  {
    path: "/Viewcompany/:id",
    title: "View Company",
    content: () => <Viewcompany />,
  },
  {
    path: "/UserManagement",
    title: "User Management",
    content: () => <UserManagement />,
  },
  {
    path: "/ResetUser/:id",
    title: "Reset User",
    content: () => <ResetUser />,
  },
  {
    path: "/SmsLog",
    title: "Sms Log",
    content: () => <SmsLog />,
  },
  {
    path: "/EmailLog",
    title: "Email Log",
    content: () => <EmailLog />,
  },
  {
    path: "/TenantSubscription",
    title: "Tenant Subscription",
    content: () => <TenantSubscription />,
  },
  {
    path: "/Administration/RoleManagement",
    title: "Role Management",
    content: () => <RoleManagement />,
  },
  {
    path: "/MasterTable",
    title: "Role Management",
    content: () => <MasterTable />,
  },
  {
    path: "/Tripbreakreport",
    title: "Role Management",
    content: () => <Tripbreakreport />,
  },
  {
    path: "/entitymanagement",
    title: "EntityManagement",
    content: () => <EntityManagement />,
  },
  {
    path: "/consignordetails",
    title: "Consignordetails",
    content: () => <Consignordetails />,
  },
  {
    path: "/Notification",
    title: "Notification",
    content: () => <Notification />,
  },
  {
    path: "/Carbonfootprints",
    title: "Carbonfootprints",
    content: () => <Carbonfootprints />,
  },
  {
    path: "/TripAllowance",
    title: "Trip Allowance",
    content: () => <TripAllowance />,
  },
  {
    path: "/reports/kpi report",
    title: "kpi report",
    content: () => <Kpireport />,
  },
  {
    path: "/reports/kpi report",
    title: "kpi report",
    content: () => <KpireportFilter />,
  },
  {
    path: "/Trend",
    title: "Trend",
    content: () => <Trend />,
  },
  {
    path: "/Demographics",
    title: "Demographics",
    content: () => <Demographics />,
  },
  {
    path: "/analytics/dashbord",
    title: "analyticsdashbord",
    content: () => <AnalyticsDashboard />,
  },
  {
    path: "/analytics/productivity",
    title: "Productivity",
    content: () => <Productivity />,
  },
  {
    path: "/livetracking",
    title: "Live Tacking",
    content: () => <LiveTracking />,
  },
  {
    path: "/kpimaster",
    title: "KPI Master",
    content: () => <Kpimaster />,
  },
  {
    path: "/tracking-track",
    title: "KPI Master",
    content: () => <></>,
  },
  {
    path: "/tracking-geo-fensing",
    title: "KPI Master",
    content: () => <></>,
  },
  {
    path: "/tracklink/:tripId",
    title: "KPI Master",
    content: () => <TrackLink />,
  },
  {
    path: "/containerReports",
    title: "TrackRight AI Cargo Reports",
    content: () => <ContainerReports />,
  },
  {
    path: "/tripMonitoring",
    title: "Trip Monitoring",
    content: () => <TripMonitoring />,
  },
  {
    path: "/tripTrack/:tripId",
    title: "Trip Track",
    content: () => <TripTrack />,
  },
  {
    path: "/tripDetails/:tripId",
    title: "Trip Track",
    content: () => <TripDetails />,
  },
  {
    path: "/TripReports",
    title: "Trip Reports",
    content: () => <TripReports />,
  },
  {
    path: "/kpiReports",
    title: "KPI Reports",
    content: () => <KpiReports />,
  },
  {
    path: "/carbonReport",
    title: "KPI Reports",
    content: () => <CarbonReport />,
  },
  {
    path: "/consignmentAI",
    title: "Consignment",
    content: () => <ConsignmentAI />,
  },
  {
    path: "/fuelEntryAI",
    title: "Fuel Entry AI",
    content: () => <FuelEntryAI />,
  },
  {
    path: "/tripListAI",
    title: "Trip List AI",
    content: () => <TripListAI />,
  },
  {
    path: "/TrackLinkAI/:aTripId",
    title: "Track Link AI",
    content: () => <TrackLinkAI />,
  },
  {
    path: "/reports",
    title: "Reports",
    content: () => <Reports />,
  },
  {
    path: "/TripReports",
    title: "Trip Reports",
    content: () => <TripReports />,
  },
  {
    path: "/kpiReports",
    title: "KPI Reports",
    content: () => <KpiReports />,
  },
  {
    path: "/carbonReport",
    title: "KPI Reports",
    content: () => <CarbonReport />,
  },
  {
    path: "/AICarbonfootprints",
    title: "AICarbonfootprints",
    content: () => <CarbonfootprintAI />,
  },
  {
    path: "/AITripAllowance",
    title: "AITrip Allowance",
    content: () => <TripAllowanceAI />,
  },
  {
    path: "/AIkpi report",
    title: "AIkpi report",
    content: () => <KpiReportAI />,
  },
  {
    path: "/AItripreport",
    title: "AITrip Report",
    content: () => <TripReportPage />,
  },
  {
    path: "/AIvehiclereport",
    title: "AIVehicle Report",
    content: () => <VehicleReportAI />,
  },
  {
    path: "/AIfuelreport",
    title: "AIFuel Report",
    content: () => <FuelReportAI />,
  },
  {
    path: "/AIcustomerreport",
    title: "AICustomer Report",
    content: () => <CustomerReportAI />,
  },
  {
    path: "/AITripbreakreport",
    title: "AITripbreak Report",
    content: () => <TripBreakAI />,
  },
  {
    path: "/customDashboardAI",
    title: "customDashboardAI",
    content: () => <CustomDashboardAI />,
  },
  {
    path: "/containerRegister",
    title: "containerRegister",
    content: () => <ContainerRegister />,
  },
  {
    path: "/GeoFence",
    title: "GeoFence",
    content: () => <GeoFenceSwitch />,
  },
  {
    path: "/GeoDetails",
    title: "GeoDetails",
    content: () => <GeoDetails />,
  },
  {
    path: "/Route",
    title: "Route",
    content: () => <Route />,
  },
  {
    path: "/RouteDetails",
    title: "RouteDetails",
    content: () => <RouteDetails />,
  },
  {
    path: "/liveTrackingMaincontainer",
    title: "Live Tracking",
    content: () => <LiveTrackSwitch />,
  },
  {
    path: "/liveTrackinghistory",
    title: "Tracking History",
    content: () => <Trackinghistory />,
  },
  {
    path: "/vehicleDetails",
    title: "Vehicles",
    content: () => <MasterTable />,
  },
  {
    path: "/Roles",
    title: "Role",
    content: () => <Role />,
  },
  // {
  //   path: "/Workshop",
  //   title: "Workshop",
  //   content: () => <Workshop />,
  // },
  {
    path: "/ServiceDetails",
    title: "ServiceDetails",
    content: () => <ServiceDetails />,
  },
  {
    path: "/InsuranceDashboard",
    title: "InsuranceDashboard",
    content: () => <InsuranceDashboard />,
  },
  {
    path: "/ServiceDashboard",
    title: "ServiceDashboard",
    content: () => <InspectionDashboard />,
  },
  {
    path: "/SpeedGovernorDashboard",
    title: "SpeedGovernorDashboard",
    content: () => <SpeedGovernorDashboard />,
  },
  {
    path: "/nexusDashboardAI",
    title: "Dashboard",
    content: () => <NexusDashboardAI />,
  },
  {
    path: "/nexusConsignAI",
    title: "Consignment",
    content: () => <NexusAI />,
  },
  {
    path: "/nexusVehicleReport",
    title: "Vehicle Report",
    content: () => <NexusVehicleReport />,
  },
  {
    path: "/nexusCustomerReport",
    title: "Customer Report",
    content: () => <NexusCustomerReport />,
  },
  {
    path: "/nexusCarbonReport",
    title: "Carbon Footprint",
    content: () => <NexusCarbonReport />,
  },
  {
    path: "/nexusFuelReport",
    title: "Fuel Report",
    content: () => <NexusFuelReport />,
  },
  {
    path: "/nexusTripAllowanceReport",
    title: "Trip Allowance",
    content: () => <NexusTripAllowanceReport />,
  },
  {
    path: "/nexusKpiReport",
    title: "Nexus KPI Report",
    content: () => <NexusKpiReport />,
  },
  {
    path: "/nexusTripReport",
    title: "Nexus Trip Report",
    content: () => <NexusTripReport />,
  },
  {
    path: "/nexusTripListAI",
    title: "Trip List AI",
    content: () => <NexusTripListAI />,
  },
    {
    path: "/nexusTrackLinkAI/:aTripId",
    title: "Nexus Track Link AI",
    content: () => <NexusTrackLinkAI />,
  },
  {
    path: "/nexusFuelEntryAI",
    title: "Fuel Entry",
    content: () => <NexusFuelAI />,
  },
  {
    path: "/NexusGeoFence",
    title: "NexusGeoFence",
    content: () => <NexusGeoFence />,
  },
  {
    path: "/NexusGeoDetails",
    title: "NexusGeoDetails",
    content: () => <NexusGeoDetails />,
  },
];

export default RoutesPath;
